export const OPEN_BROKER_CLIENT_STATE = 'OPEN_BROKER_CLIENT_STATE';
export const BROKER_CLIENT_ID_STATE = 'BROKER_CLIENT_ID_STATE';
export const BROKER_CLIENT_BROKER_ID_STATE = 'BROKER_CLIENT_BROKER_ID_STATE';

export const setBrokerClientOpen = (state) => (dispatch) => {
    dispatch({ type: OPEN_BROKER_CLIENT_STATE, state });
};

export const setBrokerClientId = (state) => (dispatch) => {
    dispatch({ type: BROKER_CLIENT_ID_STATE, state });
};

export const setBrokerClientBrokerId = (state) => (dispatch) => {
    dispatch({ type: BROKER_CLIENT_BROKER_ID_STATE, state });
};

export default {
    OPEN_BROKER_CLIENT_STATE,
    setBrokerClientOpen,
    BROKER_CLIENT_ID_STATE,
    setBrokerClientId,
    BROKER_CLIENT_BROKER_ID_STATE,
    setBrokerClientBrokerId,
};
